import {
  USER_LOGIN,
  USER_REGISTRATION,
  FORGOT_PASSWORD,
  CHANGE_PASSWORD,
  USER_UPDATE_COUNTRY,
  USER_UPDATE_LANGUAGE,
  USER_UPDATE_CURRENCY,
  USER_GET_PROFILE,
} from "../config/url";
import axios from "axios";
import store from "../store";
import authHeader from "./auth-header";
import { saveSession, clearSession } from "./session";

// The server sends the reset email synchronously; a slow send must not be
// treated as a failure (and resubmitted).
const FORGOT_PASSWORD_TIMEOUT_MS = 60000;

class AuthService {
  login(user) {
    return axios
      .post(USER_LOGIN, {
        //email: user.email, password: user.password, version: "web", token: user.recaptcha_token
        email: user.email,
        password: user.password,
        version: "web",
      })
      .then((response) => {
        // store token (localStorage so reloads and other tabs stay logged in)
        if (response.data.api_token) {
          saveSession(response.data.api_token, response.data.expires_in);
          store.dispatch("auth/storeTokenToState", response.data.api_token);
          localStorage.removeItem("invoice-details");
          localStorage.removeItem("item_category");
          localStorage.removeItem("item_recently_added_items");
          localStorage.removeItem("quotation-details");
        }

        if (user.rememberMe) {
          // Store user credentials in localStorage
          localStorage.setItem("user-details", JSON.stringify(user));
        } else {
          // Clear user credentials from localStorage
          localStorage.removeItem("user");
        }

        return response.data;
      });
  }

  updateCountry(country) {
    return axios
      .post(USER_UPDATE_COUNTRY, country, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  updateLanguage(language) {
    return axios
      .post(USER_UPDATE_LANGUAGE, language, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  updateCurrency(currency) {
    return axios
      .post(USER_UPDATE_CURRENCY, currency, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  getProfile() {
    return axios
      .get(`${USER_GET_PROFILE}?t=${new Date().getTime()}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  logout() {
    localStorage.removeItem("user");
    clearSession();
    localStorage.removeItem("invoice-details");
    localStorage.removeItem("item_category");
    localStorage.removeItem("item_recently_added_items");
    localStorage.removeItem("quotation-details");
  }

  register(user) {
    return axios
      .post(USER_REGISTRATION, {
        user_type: "web",
        app_type: "SmoothBalance",
        fullname: user.fullname,
        email: user.email,
        password: user.password,
        country: user.country,
        currency: user.currency,
        version: "web",
        language: user.language,
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  forgotPassword(user) {
    return axios
      .post(
        FORGOT_PASSWORD,
        { email: user.email },
        { timeout: FORGOT_PASSWORD_TIMEOUT_MS }
      )
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  changePassword(data) {
    return axios
      .post(CHANGE_PASSWORD, data, {
        headers: authHeader(),
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
}

export default new AuthService();
